/* eslint-disable no-unused-vars */
import { mobileLogin, getSmsCode, getEmailCode, emailLogin } from '@/api/index'
import i18n from '@/lang/index'
import { Message } from 'element-ui'
import { success, fail, failMsg } from '@/libs/utils'
import { setSession, getSession, delAllSession } from '@/libs/storage'
import Cookies from 'js-cookie'
import { getType } from '@/utils/wxh_utils'
const state = {
    loginInfo: getType(Cookies.get('loginInfo')) === 'object' ? Cookies.get('loginInfo') : {},
    userId: Cookies.get('userId') || '',
    token: Cookies.get('token') || '',
    userType: Cookies.get('userType') || '',
}

const actions = {
    // login
    async mobileLogin({ commit }, context) {
        try {
            let data = await mobileLogin(context)
            if (data.result) {
                Message.success(i18n.t('loginForm.loginSuccess'))
                commit('MOBILELOGIN', data)
            }
        } catch (error) {
            failMsg(error)
            return Promise.reject(error)
        }
    },
    /**
     * 邮箱登录
     * Object
     * Object[email]
     * Object[emailCode]
     */
    async emailLogin({ commit }, context) {
        try {
            const data = await emailLogin(context)
            commit('MOBILELOGIN', data)
            Message.success(i18n.t('loginForm.loginSuccess'))
        } catch (error) {
            failMsg(error)
            return Promise.reject(error)
        }
    },
    /**
     * 获取手机验证码
     */
    async getCodeSms({ commit }, context) {
        try {
            await getSmsCode({ mobile: context })
            success()
        } catch (error) {
            failMsg(error)
            return Promise.reject()
        }
    },
    /**
     * 获取邮箱验证码
     */
    async getEmailCode({ commit }, context) {
        try {
            await getEmailCode(context)
            success()
        } catch (error) {
            failMsg(error)
            return Promise.reject()
        }
    },
    /**
     * 退出登录
     */
    logout() {},
}

const mutations = {
    // 修改state里的数据
    MOBILELOGIN(state, params) {
        const info = params.data

        Cookies.set('token', info.token)
        Cookies.set('userId', info.userId)
        Cookies.set('userType', info.userType)

        state.userId = info.userId
        state.token = info.token
        state.userType = info.userType

        // state.loginInfo = info
    },
    LOGOUT() {
        state.userId = ''
        state.token = ''
        state.loginInfo = {}

        Cookies.remove('token')
        Cookies.remove('userId')
        Cookies.remove('loginInfo')

        // delAllSession()
    },
    // 页面销毁时移除本地存储数据
    removeLoginInfo(state) {
        // sessionStorage.removeItem('loginInfo')
        Cookies.remove('loginInfo')
        state.loginInfo = {}
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
